import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

/** Only moment's built-in `en` locale is bundled, so a plain MomentDateAdapter starts weeks on Sunday even for sv_SE. */
@Injectable()
export class MondayFirstDateAdapter extends MomentDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}
